import { graphql, HeadFC, PageProps, useStaticQuery } from 'gatsby';
import React, { useState } from 'react';
import { TeamPageQuery } from '../../../graphql-types';
import Header from '../../components/Header/Header';
import { gradient } from '../../components/controls/Gradient';
import Footer from '../../components/Footer';
import { TeamDetail, TeamDetailListing } from '../../components/TeamPage/TeamCard/model';
import TeamMemberDetail from '../../components/TeamPage/TeamMemberDetail';
import { Helmet } from 'react-helmet';

type TeamPageContext = { slug: string };

export default function TeamPage(props: PageProps<TeamPageQuery, TeamPageContext>) {
  const teamList = new TeamDetailListing();
  let descriptionValue =
    'Meet the NuBorrow team - experts in financial solutions and lending innovation.';
  let teamMemberName = '';
  for (let item of props?.data?.allStrapiTeamMember?.edges) {
    let obj = [item]?.find((find) => find.node.slug == props?.pageContext?.slug);
    obj && teamList.add(new TeamDetail(obj.node));
    if (obj) {
      descriptionValue = obj.node.description
        ? obj.node.description
        : 'Meet the NuBorrow team - experts in financial solutions and lending innovation.';
      teamMemberName = obj?.node?.name ? obj.node.name : '';
    }
  }
  return (
    <>
      <Helmet>
        <title>{`Nuborrow | Team | ${teamMemberName}`}</title>
        <meta name="description" content={descriptionValue} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={`Nuborrow | Team | ${teamMemberName}`} />
        <meta property="og:description" content={descriptionValue} />
      </Helmet>
      <div className="overflow-hidden">
        <Header />
        <div className="container flex flex-col justify-center md:my-20 2xl:py-20">
          <TeamMemberDetail member={teamList} />
        </div>
        <div className={`${gradient}`}>
          <Footer />
        </div>
      </div>
    </>
  );
}

export const TeamMemberPageQuery = graphql`
  query TeamPage {
    allStrapiTeamMember {
      edges {
        node {
          joined(formatString: "MMMM DD, YYYY")
          id
          name
          role
          slug
          verified
          videoUrl
          videoTitle
          reviews
          role
          related_tags {
            tag
          }
          location
          email
          publishedAt
          publishedAtRel: publishedAt(fromNow: true)
          publishedAtFormatted: publishedAt(formatString: "MMMM DD, YYYY")
          photo {
            localFile {
              childImageSharp {
                gatsbyImageData(placeholder: BLURRED, layout: CONSTRAINED, width: 350, height: 445)
              }
            }
          }
          description
          bannerImage {
            localFile {
              childImageSharp {
                gatsbyImageData(
                  placeholder: BLURRED
                  layout: CONSTRAINED
                  width: 445
                  height: 445
                  formats: [AUTO, WEBP]
                )
              }
            }
          }
          signature {
            localFile {
              childImageSharp {
                gatsbyImageData(
                  placeholder: BLURRED
                  layout: CONSTRAINED
                  transformOptions: { fit: COVER }
                  formats: [AUTO, WEBP]
                )
              }
            }
          }
          biography {
            data {
              id
              childMarkdownRemark {
                rawMarkdownBody
                html
                timeToRead
              }
              biography
            }
          }
        }
      }
    }
  }
`;
export const Head: HeadFC = () => {
  const icons: Record<string, string | null | undefined> = {
    'favicon.ico': ''
  };
  return (
    <>
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={'nuborrow.com/team'} />
      <meta property="og:site_name" content="Nuborrow" />
      {icons['favicon.ico'] && <link rel="icon" href="/favicon.ico" sizes="any" />}
      <script
        defer
        dangerouslySetInnerHTML={{
          __html: `setTimeout(function() {
        (function(w,d,s,l,i){
          w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});
          var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
          j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;
          f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-5LDWQSZ');
      }, 3500);`
        }}
      />
      <script type="application/ld+json">
        {`
         {         
          "@context": "https://schema.org/",         
          "@type": "WebPage",         
          "@id": "#WebPage",         
          "url": "https://nuborrow.com/team",          
          "name": "Nuborrow - Mortgage Broker"
        }
        `}
      </script>
      <noscript
        dangerouslySetInnerHTML={{
          __html: `
          <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5LDWQSZ"
            height="0" width="0" style="display:none;visibility:hidden"></iframe>
        `
        }}
      />
    </>
  );
};
